<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Painel</h1>
      <section class="col-lg-12">
        <article v-if="dadosModerar > 0" class="col-xs-12 col-sm-6 col-md-4">
          <header>
            <font-awesome-icon :icon="'list-alt'" class="fa-2x" style="color:white" />
          </header>
          <h2>{{ dadosModerar }}</h2>
          <p>Total de dados para moderar</p>
          <router-link to="/admin/dado/moderacao">
            <span>detalhes aqui</span>
            <font-awesome-icon :icon="'arrow-right'" />
          </router-link>
        </article>
      </section>
    </div>
  </div>
</template>

<script>
import { request } from '@/request'
export default {
  name: 'painel',
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  data () {
    return {
      dadosModerar: 0,
    }
  },
  created() {
    this.loadModeracao()
  },
  methods: {
    async loadModeracao() {
      const { status, data } = await request.get('moderacao?count=true')
      
      if (status !== 200) return this.$toastr.e('Não foi possivel carregar o total de moderações de dados!')

      this.dadosModerar = data
    }
  }
}
</script>

<style scoped>
article {
  border: 2px solid #11615C;
  border-radius: 16px;
  padding: 16px;
}

article:hover {
  background-color: #A2D3D0;
}

article header {
  display: flex;
  justify-content: center;
  width: 48px;
  padding: 10px;
  border-radius: 40%;
  background-color: #11615C;
}

article p {
  font-size: 18px;
}

article .divider {
  width: 111%;
  margin-left: -16px;
  margin-right: -16px;
  padding-block: 8px;
  border-top: 1px solid #11615C;
}

article a {
  margin-top: 20px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #11615C;
  cursor: pointer;
}

h1,
h2,
h3 {
  color: #0B3B39;
  /* ou #11615C se quiser mais unidade */
}

/* Cor para parágrafos */
p {
  color: #333333;
  /* ou #4F4F4F para uma leve suavidade */
}
</style>



// WEBPACK FOOTER //
// src/views/admin/painel/index.vue